import { useState, useMemo, useRef, useContext } from "react";
import CustomSelect from "./CustomSelect";
import { Typography, Button, Menu, IconButton } from '@mui/material';
import { deselectAllRows, downloadSelectedData } from "../../../components/admin/common/OZDataGrid/GridUtil";
import { showCustomComponentNotification, showErrorNotification, showSuccessNotification } from "../../../components/admin/common/NotiService";
import AddAgentsToGroup from "./AddAgentsToGroup";
import { bulkUpdateAgentsById } from "../../../services/api-service";
import { OZContext } from "../../../contexts/OZContext";
import { useNavigate } from "react-router-dom";

const bulkActionMapping = {
    Active: 'active',
    Deactivate: 'deactivate',
    Locked: 'lock',
    Unlock: 'unlock'
}

export const BulkActionComponent = (bulkOptionProps) => {

    const [agentsToGroupMenuAnchorE1, setAgentsToGroupMenuAnchorE1] = useState(false);
    const { setIsLoaderOpen } = useContext(OZContext);
    const anchorRef = useRef();
    const [openAddtoGroup, setOpenAddtoGroup] = useState(false);
    const navigate = useNavigate();

    const ClickToOpenMenu = () => {
        setTimeout(() => setAgentsToGroupMenuAnchorE1(anchorRef?.current), 1);
        setOpenAddtoGroup(true)
    };
    const handleClose = () => {
        setAgentsToGroupMenuAnchorE1(null);
        setOpenAddtoGroup(false)
    };

    const basicTextStyle = useMemo(
        () => ({
            fontSize: "14px",
            fontWeight: "400",
            color: "#212121",
        }),
        []
    );

    function gotoBulkOperationTranscation() {
        navigate('/admin/bulkOperationStatus')
    }

    async function updateAgentStatus(userEnteredValues) {
        try {
            setIsLoaderOpen(true)
            let cloneOfSelectedAgentData = structuredClone(bulkOptionProps.list)
            let agentIds = cloneOfSelectedAgentData.map((agentData) => agentData.id);
            agentIds = agentIds.join(',');
            const resp = await bulkUpdateAgentsById({ action: bulkActionMapping[userEnteredValues], ids: agentIds })
            if (resp.status === 'IN_PROGRESS') {
                showCustomComponentNotification({
                    component: (
                        <label style={{ fontSize: '14px', fontWeight: '400', color: '#212121' }}>
                            {(resp?.message || 'Update in Progress')} <br />
                            <span style={{ textDecoration: 'none', cursor: 'pointer', color: '#3d8bf8', fontSize: '12px', }}
                                onClick={() => { gotoBulkOperationTranscation() }}
                            >
                                Click here to check the status
                            </span>
                        </label >
                    ),
                    variant: 'success',
                });
            } else if (resp?.message) {
                showErrorNotification(resp?.message)
            }
            deselectAllRows();
            bulkOptionProps.getAgents();
        } catch (e) {
            showErrorNotification("Bulk Action Failed")
            console.log("Error", e)
        } finally {
            setTimeout(() => {
                deselectAllRows();
                setIsLoaderOpen(false)
            }, 200);
        }
    }

    function downloadAgentData(formValue) {
        let fileType = formValue.toLowerCase()
        downloadSelectedData(fileType, "AgentGroupList")
        deselectAllRows()
    }

    return (
        <div>
            {bulkOptionProps?.list?.length > 0 && (
                <div className="oz-agent-bulk-actions-container">
                    <Typography sx={{
                        fontSize: "12px",
                        fontWeight: 400,
                        color: '#000000'
                    }}>{bulkOptionProps?.list?.length} Users Selected</Typography>
                    <CustomSelect
                        name="status"
                        placeholder='Status'
                        options={['Active', 'Deactivate', 'Locked', 'Unlock']}
                        list={bulkOptionProps.list}
                        onChange={(value) => { updateAgentStatus(value) }}
                    />
                    <CustomSelect
                        name="export"
                        placeholder='Export'
                        options={['CSV', 'Excel', 'XML', 'PDF']}
                        onChange={(value) => { downloadAgentData(value) }}
                    />
                    <div className="oz-agent-bulk-actions-add-to-group-container">
                        <Button ref={anchorRef} onClick={ClickToOpenMenu}
                            variant="text"
                            sx={{
                                ...basicTextStyle, paddingLeft: '5px', color: '#3D8BF8'
                            }}
                        >
                            <img className="oz-agent-bulk-actions-add-to-group-image" onClick={null}
                                src={`${process.env.PUBLIC_URL}/icons/anotherlevelblue.svg`}
                                alt="anotherbutton"
                            ></img>
                            Add To Group</Button>
                        <Button ref={anchorRef} onClick={() => { deselectAllRows() }}
                            sx={{
                                ...basicTextStyle, paddingLeft: '5px', cursor: "pointer",
                                color: '#536580'
                            }}
                        > Clear All</Button>
                    </div>
                    <div >
                        <Menu
                            anchorEl={agentsToGroupMenuAnchorE1} open={Boolean(agentsToGroupMenuAnchorE1)} onClose={handleClose}
                            sx={{
                                "& .MuiMenu-paper": {
                                    backgroundColor: "white",
                                    width: "458px",
                                    height: "409px",
                                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.06)",
                                    border: "0.0625rem solid #E6E5E6",
                                    borderRadius: "12px",
                                    position: "relative",
                                    marginTop: '-27px'
                                },
                            }}
                        >
                            <div className="oz-agent-bulk-actions-add-to-group-inner">
                                <div className="oz-agent-bulk-actions-add-to-group-inner-icon-button">
                                    <Typography flexGrow={1}> Add {bulkOptionProps?.list?.length} Agents to group
                                    </Typography>
                                    <IconButton
                                        aria-label="close"
                                        onClick={() => { handleClose() }}
                                        sx={{
                                            color: '#99A0A8',
                                            alignSelf: "center"
                                        }}
                                    >
                                        <img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt='x' ></img>
                                    </IconButton>
                                </div>
                                {openAddtoGroup && <AddAgentsToGroup initialData={bulkOptionProps.initialData} autoCompleteList={bulkOptionProps.autoCompleteList} list={bulkOptionProps.list} handleClose={handleClose} gotoBulkOperationTranscation={gotoBulkOperationTranscation} />}
                            </div>
                        </Menu>
                    </div>
                </div >
            )
            }
        </div >
    )
}
